"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FreeFranceDirectoryPreview() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const items = [{
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/louvre_museum_exterior.png",
    title: "Free Museums",
    description: "Discover world-class museums that offer free admission on specific days or for certain collections.",
    link: "/FreeFranceDirectoryPage"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/luxembourg_gardens_park.png",
    title: "Public Parks",
    description: "Explore beautiful parks and gardens across France where you can relax and enjoy nature at no cost.",
    link: "/FreeFranceDirectoryPage"
  }, {
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/walking_tour_paris_streets.png",
    title: "Free Walking Tours",
    description: "Join tip-based walking tours to learn about French history, architecture, and local culture.",
    link: "/FreeFranceDirectoryPage"
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="free-france-directory-preview" className="section-light">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {items.map((item, i) => <div key={i} data-index={i} ref={refs[i]} className="group" style={{
          opacity: visibilities[i] ? 1 : 0,
          transform: visibilities[i] ? "translateY(0)" : "translateY(20px)",
          transition: `opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) ${i * 150}ms, transform 150ms cubic-bezier(0.4, 0, 0.2, 1) ${i * 150}ms`
        }}>
              <Card className="h-full overflow-hidden transition-all duration-medium ease-smooth group-hover:-translate-y-1 group-hover:shadow-medium">
                <img src={item.image} alt={item.title} className="h-64 w-full object-cover" />
                <CardHeader>
                  <CardTitle className="font-display text-xl">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative pb-16">
                  <p className="text-sm leading-relaxed text-muted-foreground">
                    {item.description}
                  </p>
                  <div className="absolute bottom-0 left-0 right-0 translate-y-full px-6 pb-6 opacity-0 transition-all duration-medium ease-smooth group-hover:translate-y-0 group-hover:opacity-100">
                    <Link to={item.link}>
                      <Button className="w-full">
                        Explore
                      </Button>
                    </Link>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}